<template>
<RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
  <div class="start-page" v-else style="margin-top:-10px !important;margin-right:-20px;margin-left:-20px;">
    <b-row class="px-pad border-bottom" style="height:42px">
      <b-col cols="6" class="px-4">
        <h2 class="custom-page-title mb-2 mt-1">Enter SKU</h2>
      </b-col>
      <b-col md="6" class="text-right px-4">
        <b-button variant="outline-primary" size="sm" @click="exportModal()">
          <span class="la la-download la-lg mr-2"></span>Export Sku
        </b-button>

        <router-link class="event-link float-right mt-2" :to="{name:'ProductSettings'}">
          <i class="la la-remove la-lg text-decoration-none text-dark pl-2 cursor_pointer"></i>
        </router-link>
      </b-col>
    </b-row>
    <div
      class="duplicate_details pl-2 pt-3 pr-2 mb-2 bg-light"
      style="width:100%;stretch-height:100%;border-right:0 !important;"
    >
      <h6
        class="pl-4 py-2"
      >Finding it difficult to enter SKU for products individually? Export the products, add SKUs, and import them into products to add SKUs in bulk.</h6>
    </div>

    <div class="table-responsive" id="scrollCol">
      <table class="table table-hover index-table">
        <thead>
          <tr>
            <th style="width:200px !important">Name</th>
            <th style="min-width:250px !important">Description</th>
            <th style="min-width:150px !important">SKU</th>
            <th style="width:95px !important"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in lists" :key="item.pdt_id">
            <td style="width:200px !important">
              <span class="text">{{item.pdt_name}}</span>
            </td>
            <td style="min-width:250px !important">
              <span class="text">{{item.pdt_desc}}</span>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="item.pdt_sku"
                @click="button_id=index"
              />
            </td>
            <td class="align-middle">
              <i class="fa fa-spinner fa-spin" style="font-size:18px" v-if="submitted===index"></i>
              <b-button
                variant="success"
                size="sm"
                @click="onSubmit(index)"
                v-else-if="!submitted&&button_id===index"
                style="height: 23px !important;
  width: 23px !important;border-radius: 50% !important;"
              >
                <i class="la la-check la-lg" style="position: relative;left: -7px;top: -4px;"></i>
              </b-button>

              <b-button
                variant="light"
                size="sm"
                v-if="button_id===index"
                @click="item.pdt_sku='';button_id=''"
                class="ml-2"
                style="height: 23px !important;
  width: 23px !important;border-radius: 50% !important;"
              >
                <i
                  class="la la-remove la-lg"
                  style="position: relative;left: -8px;top: -4px;"
                  @click="item.pdt_sku==''"
                ></i>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-row
      v-if="lists.length > 0"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0;margin-left:0px;margin-right:0px"
    >
      <b-col cols="6" class="mt-2 pt-1">
        <nav class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * count) + lists.length }}
            of {{ total_count }} entries
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'Productsku',query: {page: 1,show: 10} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'Productsku',query: {page: 1,show: 25} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'Productsku',query: {page: 1,show: 50} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>

      <b-col cols="6" class="mt-2 pt-1 d-md-block d-none">
        <template v-if="total_count > show">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'Productsku',query: {page: page - 1 ,show: count } }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'Productsku',query: {page: page - 1 ,show: count } }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'Productsku',query: {page: page - 1 ,show: count } }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'Productsku',query: {page: page + 1 ,show: count } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'Productsku',query: {page: Math.ceil(total_count / count),show: count,} }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'Productsku',query: {page: page + 1,show: count,} }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'SKU'"
      @downloaded="export_modal=false"
    />
  </div>
</template>
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
import store from "@/store/index";
import { mapState } from "vuex";
import RecordNotFound from "@/pages/Error/RecordNotFound";
function getPageSku(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  store
    .dispatch("products/productswithoutsku", {
      page: currentPage,
      show: show
    })
    .then((response) => {
      if (response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true,
        });
      }
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      next();
    });
}
export default {
  mixins: [scrollTable],
  data() {
    return {
      export_data: "",
      export_modal: false,
      button_id: "",
      submitted: "",
      export_xl: {
        "Product Name": "pdt_name",
        Description: "pdt_desc",
        Sku: "pdt_sku",
        "Opening Stock": "opening_stock",
        "Reorder Level": "reorder_level"
      }
    };
  },
   components: {
     RecordNotFound,
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    }
  },
  name: "ProductSku",

  methods: {
    onSubmit(index) {
      var data;
      this.submitted = index;

      data = JSON.stringify({
        pdt_id: this.lists[index].pdt_id,
        pdt_name: this.lists[index].pdt_name,
        pdt_sku: this.lists[index].pdt_sku
      });

     this.$store.dispatch("products/createsku", data).then(() => {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: this.status_message,
          type: this.status_type,
          showCloseButton: true
        });
        if (this.status_code == 200) {
          this.button_id = "";
        }

        this.submitted = "";
      });
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const response = await store
        .dispatch("products/fetchexportsku", {
          page: currentPage,
          show: show
        })
        .then(() => {
           if (this.status_code != 200) {
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true
            });
          } else {
            this.$root.$emit("bv::show::modal", "exportdata");
            return this.export;
          }
        });
      return response;
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      // this.$root.$emit("bv::show::modal", "exportdata");
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageSku(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getPageSku(routeTo, next);
  },
  computed: {
    ...mapState({
      message: state => state.products.message,
      type: state => state.products.type,
      lists: state => state.products.lists,
      count: state => state.products.count,
      total_count: state => state.products.total_count,
      export: state => state.products.export,
      status_code: (state) => state.products.status_code,
      status_message: (state) => state.products.status_message,
      status_type: (state) => state.products.status_type,
    })
  }
};
</script>
<style scoped>
.duplicate_details {
  /* background: #fff4e7; */
  padding: 7px 7px;
  max-width: 100%;
}
#scrollCol.table-responsive {
  height: calc(100vh - 205px) !important;
}
</style>